
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 11"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.665 8.98L13.673.974a.5.5 0 01.707.707l-8.715 8.715L.848 5.579a.5.5 0 01.707-.707l4.11 4.109zm5.009-.008l7.999-8a.5.5 0 01.707.708l-8.724 8.724L9.29 8.967a.5.5 0 11.725-.689l.659.694z"}})])
          )
        }
      }
    